import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Outlet } from 'react-router-dom'
import { withTranslation } from 'react-i18next'

import Dashboard from '../Dashboard'
import { selectUserRole, selectUserData } from '../../reducers/userDataReducer'
import ModalContainer from '../ModalContainer/ModelContainer'

import MaintenanceToolbar from './MaintenanceToolbar'
import RequestMaintenanceForm from './RequestMaintenanceForm/RequestMaintenanceForm'

class MaintenancePage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isModalOpen: false,
    }
    this.toggleModal = this.toggleModal.bind(this)
  }

  toggleModal() {
    this.setState((prev) => ({ ...prev, isModalOpen: !prev.isModalOpen }))
  }

  render() {
    const { t } = this.props
    return (
      <React.Fragment>
        <Dashboard.Container className={'ctp-maintenance'}>
          <MaintenanceToolbar
            toggleActive={this.toggleActive}
            toggleModal={() => this.toggleModal()}
            {...this.props}
          />
          <Outlet />
        </Dashboard.Container>
        {this.state.isModalOpen && (
          <ModalContainer
            headerTitle={t('maintenance:page.createRequestModalTitle')}
            onClose={() => this.toggleModal()}
          >
            <RequestMaintenanceForm toggleModal={() => this.toggleModal()} />
          </ModalContainer>
        )}
      </React.Fragment>
    )
  }
}

MaintenancePage.propTypes = {
  userRole: PropTypes.string,
  userData: PropTypes.object,
  children: PropTypes.element.isRequired,
  t: PropTypes.func,
}

export default connect((state) => ({
  userRole: selectUserRole(state),
  userData: selectUserData(state),
}))(withTranslation(['maintenance'])(MaintenancePage))
